// extracted by mini-css-extract-plugin
module.exports = {"container":"Privacy_container__NVQxs","container_privacy":"Privacy_container_privacy__Drjp_","container_privacy__list":"Privacy_container_privacy__list__t85Y6"};